import { Fragment } from 'react'

export type OGPImageType = {
  url: string;
  secureUrl: string;
  type?: string;
  width?: string;
  height?: string;
  alt?: string;
}

export type UseOpenGraphImagesProps = {
  enabled: boolean;
  pageImages?: Array<OGPImageType>;
}

/**
 * Open Graph image hook
 * https://ogp.me/#structured
 * @param param0 
 * @returns 
 */
export function useOpenGraphImages({ enabled, pageImages }: UseOpenGraphImagesProps) {
  if (!enabled) {
    return <></>
  }

  return pageImages && pageImages.map((i, k) => (
    <Fragment key={k}>
      {i.url && <meta key='og_image' property='og:image' content={i.url} />}
      {i.secureUrl && <meta key='og_image_secure' property='og:image:secure_url' content={i.secureUrl} />}
      {i.type && <meta key='og_image_type' property='og:image:type' content={i.type} />}
      {i.width && <meta key='og_image_width' property='og:image:width' content={i.width} />}
      {i.height && <meta key='og_image_height' property='og:image:height' content={i.height} />}
      {i.alt && <meta key='og_image_alt' property='og:image:alt' content={i.alt} />}
    </Fragment>
  ))
}
